import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import Home from "../app/page";
import { registerPlanformServiceWorker } from "../app/pwa";
import "../app/globals.css";

if (typeof document !== "undefined") {
  const root = document.getElementById("root");

  if (!root) {
    throw new Error("Planform could not find its application root.");
  }

  createRoot(root).render(
    <StrictMode>
      <Home />
    </StrictMode>,
  );

  registerPlanformServiceWorker();
}
